
const lastUpdate = '2026-06-19';
export const helpTitle = 'EasyMap Toolbox Help';

export const helpContent = `
<h1>${helpTitle}</h1>

<h2>Overview</h2>
<p>The EasyMap toolbox gives you quick access to the tools in EasyMap. You can
customize which tools appear and the order they appear in, and save different
toolbox layouts for different jobs.</p>

<h2>Opening a tool</h2>
<ol>
  <li>Open the toolbox by clicking its icon <i class="fas fa-tools"></i> on the left of the map.</li>
  <li>Click any tool in the list to launch it. The toolbox closes and the tool opens.</li>
</ol>

<h2>Your permanent default toolbox</h2>
<p>Every user has a <strong>User Default</strong> toolbox that always loads when you
open EasyMap. It starts out with the standard set of tools (copied from the
system-wide default) and is listed first whenever you load a toolbox. The
User Default is permanent — it can be <em>edited</em>, but it cannot be renamed
or deleted, so you always have a toolbox to fall back on.</p>

<h2>Customizing the toolbox</h2>
<p>Click the edit icon <i class="fas fa-gears"></i> to enter edit mode. From there you can:</p>
<ul>
  <li><strong>Turn tools on or off</strong> with the checkboxes (you only see tools you have permission to use).</li>
  <li><strong>Reorder tools</strong> by dragging them with the handle.</li>
</ul>
<p>When you are done, choose how to keep your changes:</p>
<ul>
  <li><i class="fas fa-floppy-disk"></i> <strong>Save</strong> — update the toolbox you are currently editing.</li>
  <li><i class="fas fa-file-circle-plus"></i> <strong>Save as new</strong> — keep your changes as a brand-new toolbox.</li>
  <li><i class="fas fa-eraser"></i> <strong>Start from scratch</strong> — clear everything and build a new toolbox from nothing.</li>
</ul>

<h2>Loading, renaming and deleting toolboxes</h2>
<p>Click the load icon <i class="fas fa-folder-open"></i> to switch between your saved
toolboxes. Your own custom toolboxes can be renamed or deleted from this list.
The permanent <strong>User Default</strong> and the shared <strong>Global</strong>
default cannot be renamed or deleted.</p>

<h2>The global default (administrators)</h2>
<p>Administrators can edit the shared <strong>Global</strong> default toolbox — the
template new users start from. Like the User Default, the global default is
permanent and cannot be deleted.</p>

<p>For further assistance, please refer to the documentation or contact support.</p>

<div class="last-update">Last Updated: ${lastUpdate}</div>
`;

export default helpContent;
